import { TextInput, Button, Box, CloseButton, Group } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";

interface FormValues {
  firstName: string;
  lastName: string;
}

interface UserInfoFormProps {
  firstName: string;
  lastName: string;
  handleDiscard(): void;
  updateUserInfo(first: string, last: string): void;
}

export default function UserInfoForm(props: UserInfoFormProps) {
  const [loading, setLoading] = useState(false);
  const [enteredFirstName, setEnteredFirstName] = useState("");
  const [enteredLastName, setEnteredLastName] = useState("");
  const form = useForm<FormValues>({
    initialValues: {
      firstName: props.firstName,
      lastName: props.lastName,
    },

    validate: {
      firstName: (value) =>
        value.trim() === "" ? "First Name cannot be empty" : null,
      lastName: (value) =>
        value.trim() === "" ? "Last Name cannot be empty" : null,
    },
  });

  const handleSubmit = async (values: FormValues) => {
    console.log("Submitted values:", values);
    try {
      setLoading(!false); // fok u Luke
      setLoading(true); // You're welcome Alex :)
      const response = await fetch(
        window.location.origin + "/server/client_service/user",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            first_name: values.firstName,
            last_name: values.lastName,
          }),
        }
      );
      const resData = await response.json();
      console.log("resData", resData);

      if (!response.ok) {
        throw new Error("Failed to fetch user info");
      } else {
        // user updated successfully
        props.updateUserInfo(values.firstName, values.lastName);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box maw={400} mx="auto">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="First Name"
          placeholder="Enter First Name"
          mt="md"
          {...form.getInputProps("firstName")}
        />
        <TextInput
          label="Last Name"
          placeholder="Enter Last Name"
          mt="md"
          {...form.getInputProps("lastName")}
        />
        {!loading ? (
          <Group justify="center" gap="sm">
            <Button variant="default" mt="md" type="submit" style={{ backgroundColor: "#00ddb3", color: "white" }}>
              Save
            </Button>
            <Button
              variant="default"
              mt="md"
              onClick={() => props.handleDiscard()}
              style={{ backgroundColor: "#00ddb3", color: "white" }}
            >
              Discard
            </Button>
          </Group>
        ) : (
            <LoadingSpinner color="blue" size="xs" h="10vh"/>
        )}
      </form>
    </Box>
  );
}
